"use client";

import { c as _c } from "react/compiler-runtime";
import FileDropzone from "@/components/fancy/file-dropzone";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { TImage } from "@/types/types";
import Image from "next/image";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import VisuallyHiddenAlt from "../utility/visually-hidden";
type ReceiptDropzoneFieldProps = {
  formFieldKey: string;
};
export default function ReceiptDropzoneField(t0) {
  const $ = _c(10);
  const {
    formFieldKey
  } = t0;
  const {
    control,
    setValue
  } = useFormContext();
  const [previewImage, setPreviewImage] = useState();
  let t1;
  if ($[0] !== formFieldKey || $[1] !== setValue) {
    t1 = function onSelectImage(selectedImage) {
      if (selectedImage) {
        setPreviewImage(selectedImage);
        setValue(formFieldKey, selectedImage.id, {
          shouldDirty: true
        });
      }
    };
    $[0] = formFieldKey;
    $[1] = setValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onSelectImage = t1;
  let t2;
  if ($[3] !== onSelectImage || $[4] !== previewImage) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem><FormLabel>Receipt Image</FormLabel><div className="flex min-h-64 max-w-2xl rounded-5xl"><FileDropzone fileType="image" multiple={false} onSelectFileAction={files => {
            const firstImage = files.find(_temp);
            if (firstImage) {
              onSelectImage(firstImage);
            }
          }} className="rounded-xl" /></div>{previewImage && <div className="flex items-center gap-4 p-2"><p className="text-sm">File: {previewImage.originalName}</p><Dialog><DialogTrigger type="button"><Image src={previewImage.url} alt="Thumbnail image of receipt" height={80} width={80} className="h-10 w-auto cursor-pointer rounded-md bg-muted" /></DialogTrigger><DialogContent className="h-[90%] w-fit overflow-hidden border-0 bg-transparent p-0"><VisuallyHiddenAlt><DialogTitle /><DialogDescription /></VisuallyHiddenAlt><Image src={previewImage.url} alt="Thumbnail image of receipt" height={1000} width={1000} className="h-full w-auto cursor-pointer overflow-auto object-cover" /></DialogContent></Dialog></div>}<FormControl><Input {...field} value={field.value || ""} type="hidden" /></FormControl><FormMessage /></FormItem>;
    };
    $[3] = onSelectImage;
    $[4] = previewImage;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== control || $[7] !== formFieldKey || $[8] !== t2) {
    t3 = <FormField control={control} name={formFieldKey} render={t2} />;
    $[6] = control;
    $[7] = formFieldKey;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(file) {
  return file !== null && "id" in file;
}